<template>
  <div>
    <b-container fluid="xl" class="px-0 px-md-2">
      <b-row
        style="max-height: 80px"
        class="bg-white flex-nowrap"
        align-v="center"
        align-h="between"
        no-gutters
      >
        <b-col cols="auto" order="2" order-lg="1">
          <Logo background class="bg-white position-relative top-header-logo"></Logo>
        </b-col>
        <b-col cols="auto" class="font-responsive" order="1" order-lg="2">
          <NumbersBoard :value="counters && counters.withGiftGiver" :text="$t('home.hasDonor')" />
        </b-col>
        <b-col cols="auto" class="font-responsive" order="3" order-lg="3">
          <NumbersBoard
            red
            :value="counters && counters.withoutGiftGiver"
            :text="$t('home.waitingForHelp')"
          />
        </b-col>
      </b-row>
      <b-row v-if="false">
        <b-skeleton animation="none" height="80px" width="100%" class="mb-0"></b-skeleton>
      </b-row>
    </b-container>
    <b-container fluid class="px-0">
      <b-row class="bg-salmon-500" no-gutters align-content="center">
        <b-col cols="12" md="4" lg="5">
          <b-img
            :src="topHeaderImage"
            alt="Dziecko w Akademii Przyszłości"
            width="633px"
            height="387px"
            class="w-100 h-100"
            style="object-fit: cover"
          ></b-img>
        </b-col>
        <b-col v-orphans cols="12" md="8" lg="7" class="p-3 p-md-5" align-self="center">
          <h1 class="text-blue-500 lead font-weight-bold font-italic mb-3">
            {{ $t('home.mainLead.title') }}
          </h1>
          <p
            class="d-block d-md-none text-base text-blue-500 mb-4"
            v-html="$t('home.mainLead.subtitleMobile')"
          ></p>
          <p
            class="d-none d-md-block text-base text-blue-500 mb-4"
            v-html="$t('home.mainLead.subtitle')"
          ></p>
          <div
            @click="showMobileList"
            class="d-flex align-items-center mb-0 mb-lg-3 justify-content-between"
          >
            <h2 class="text-blue-500 lead font-weight-bold mb-0 font-italic">
              {{ $t('home.howToHelp') }}
            </h2>
            <b-icon
              :icon="mobileListVisible ? 'dash' : 'plus'"
              class="d-block d-lg-none"
              variant="blue-500"
              scale="2"
            ></b-icon>
          </div>
          <transition name="slide">
            <b-row v-if="mobileListVisible" class="px-0 mt-3" no-gutters>
              <b-col
                v-for="(item, index) in list"
                :key="index"
                cols="12"
                lg="4"
                class="background-icon-star rounded border border-2 border-salmon-500 hover-border"
              >
                <b-row no-gutters align-h="center" align-v="center" align-content="center">
                  <b-col
                    cols="12"
                    @click="showModal(index)"
                    class="px-0 px-lg-3 mb-0 py-2 py-lg-4 mx-0 mx-lg-1 d-flex"
                  >
                    <p
                      class="mb-0 text-base font-weight-bold text-blue-500 py-2 text-left px-0 px-lg-3"
                      v-html="$t(item.label)"
                    ></p>
                    <div class="py-2 my-1">
                      <b-icon-plus
                        class="d-none d-lg-block"
                        variant="blue-500"
                        scale="2"
                      ></b-icon-plus>
                    </div>
                  </b-col>
                  <b-col cols="12" class="d-flex d-lg-none px-0">
                    <p class="text-blue-500 text-base" v-orphans>
                      {{ $t(`${item.text}`) }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </transition>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      v-model="modal"
      hide-footer
      centered
      body-class="px-5"
      header-border-variant="none"
      header-class="top-header-custom-modal px-5"
    >
      <template #modal-title>
        <p class="lead font-weight-bold text-blue-500 mb-0" v-orphans>
          {{ $t(list[listIndex].label) }}
        </p>
      </template>
      <template #default>
        <MoneyProgressBar v-if="listIndex === 0" class="pb-4" showValueDescription>
        </MoneyProgressBar>
        <MoneyProgressBar
          v-if="listIndex === 1"
          class="pb-4"
          :fundraising="{ paid_amount: 12500 }"
          showValueDescription
        >
        </MoneyProgressBar>
        <MoneyProgressBar v-if="listIndex === 2" class="pb-4" :fundraising="{ paid_amount: 12500 }">
        </MoneyProgressBar>
        <p class="text-base text-blue-500" v-orphans v-html="$t(list[listIndex].text)"></p>
      </template>
    </b-modal>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCountersStore } from '@/stores/counters'

import Logo from '@/components/widgets/Logo.vue'
import NumbersBoard from '@/components/widgets/NumbersBoard.vue'
import MoneyProgressBar from '@/components/widgets/childCard/MoneyProgressBar.vue'

const mobileMaxSize = ref(1170)
const mobileListVisible = ref<boolean>(window.innerWidth >= mobileMaxSize.value)
const modal = ref(false)
const listIndex = ref<number>(0)
const list = ref([
  {
    label: 'home.steps.1',
    text: 'home.stepDescription.1'
  },
  {
    label: 'home.steps.2',
    text: 'home.stepDescription.2'
  },
  {
    label: 'home.steps.3',
    text: 'home.stepDescription.3'
  }
])

function showMobileList(): void {
  if (window.innerWidth < mobileMaxSize.value) {
    mobileListVisible.value = !mobileListVisible.value
  }
}
function resizeEvent(): void {
  mobileListVisible.value = window.innerWidth >= mobileMaxSize.value
}
resizeEvent()

function showModal(index: number) {
  if (window.innerWidth >= mobileMaxSize.value) {
    modal.value = true
    listIndex.value = index
  }
}

const countersStore = useCountersStore()
await countersStore.fetchCounters()

const { getCounters: counters } = storeToRefs(countersStore)

window.addEventListener('resize', resizeEvent)
onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeEvent)
})

const topHeaderImage = new URL(
  '/src/assets/images/akademia_przyszlosci_dziecko.png',
  import.meta.url
).href
</script>
